import React from 'react';
import { useTimezone } from '../../context/TimezoneContext';

const COMMON_TIMEZONES = [
  'Europe/Madrid',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'America/New_York',
  'America/Los_Angeles',
  'Asia/Tokyo',
  'Asia/Dubai',
  'Australia/Sydney'
];

export const TimezoneSelect: React.FC = () => {
  const { timezone, setTimezone } = useTimezone();

  return (
    <select
      value={timezone}
      onChange={(e) => setTimezone(e.target.value)}
      className="w-full text-sm border border-[#0044CC] px-2 py-1.5 pr-12 bg-[#0044CC] text-white focus:outline-none focus:ring-1 focus:ring-white/20 focus:border-white/20 appearance-none"
      style={{ backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNC4yOTQgNi41NzVsNC41NzUgNC41NzUgNC41NzUtNC41NzUtMS40MTQtMS40MTRMOC44NTkgOC4xNDUgNS43MDggNS4xMzNsLTEuNDE0IDEuNDEzeiIvPjwvc3ZnPg==)', backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.75rem center', backgroundSize: '1rem' }}
    >
      {COMMON_TIMEZONES.map((tz) => (
        <option key={tz} value={tz}>
          {tz.replace('_', ' ')}
        </option>
      ))}
    </select>


  );
};